export class SpecialEvent {
	constructor() {
	}
} 
